<template>
  <div>
    <PesquisaDentistaModal
        v-if="modalSelecionarDentista"
        v-model="modalSelecionarDentista"
        @fecharModalPesquisaDentista="fecharModalSelecionarDentista"
        @confirmarDentistaSelecionado="selecionarDentista"
    />
    <v-card elevation="0" class="container-atendimento">
      <v-card-title>
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" @click="fechar" icon color="white">
              <v-icon>arrow_back</v-icon>
            </v-btn>
          </template>
          Voltar
        </v-tooltip>
        <v-toolbar-title class="ml-2">Iniciar novo atendimento</v-toolbar-title>
      </v-card-title>
      <v-card-text class="card-content">
        <v-container fluid grid-list-xl white>
          <div class="container-header-atendimendo-selecionado">
            <div class="selecionado-label">
              <span class="primary--text">Dentista</span><br/>
              <label>{{ dentistaSelecionado.nome }}</label>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon color="primary" class="ml-2" @click="abrirModalSelecionarDentista">
                    <v-icon>search</v-icon>
                  </v-btn>
                </template>
                Selecionar o dentista
              </v-tooltip>
            </div>
          </div>
          <v-row wrap align-center white class="mt-2">
            <v-col cols="12" md="12" sm="12" xs="12">
              <v-textarea
                  v-model="dadosGerais.descricao"
                  name="descricao"
                  placeholder="Informe a descrição do atendimento"
                  filled
                  auto-grow
                  counter="500"
                  maxlength="500"
                  class="textarea-descricao"
              >
                <template v-slot:label>Descrição</template>
              </v-textarea>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="actions-footer">
        <v-btn class="botao-cancelar-edicao" @click="fechar" outlined>Cancelar</v-btn>
        <v-btn class="botao-salvar ml-4" @click="salvar" outlined>Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import {actionTypes} from '@/core/constants'
import PesquisaDentistaModal from '@/views/modais/PesquisaDentistaModal.vue'

export default {
    components: {PesquisaDentistaModal},
    nome: 'OdontogramaNovoAtendimento',
    data() {
        return {
            idPaciente: null,
            modalSelecionarDentista: false,
            dentistaSelecionado: {
                id: null,
                nome: 'Não selecionado',
            },
            dadosGerais: {
                descricao: null,
                dataInicio: null,
                dataFim: null,
                dentistaId: null,
            },
        }
    },
    mounted() {
        this.setarIdPaciente()
        this.setarDentistaPadrao()
    },
    methods: {
        ...mapGetters([
            'getUsuarioLogado'
        ]),
        setarIdPaciente() {
            if (this.$route.params.id) {
                this.idPaciente = this.$route.params.id
            }
        },
        setarDentistaPadrao() {
            const usuario = this.getUsuarioLogado()
            if (usuario.ehDentista) {
                this.dentistaSelecionado = {
                    id: usuario.id,
                    nome: usuario.nome
                }
            }
        },
        fechar() {
            this.$emit('fecharAtendimento')
        },
        async salvar() {
            if (this.isEventoValido()) {
                this.setMensagemLoading('Iniciando atendimento...')
                const input = {
                    pacienteId: this.idPaciente,
                    dentistaId: this.dentistaSelecionado.id,
                    descricao: this.dadosGerais.descricao
                }
                const resposta = await this.$store.dispatch(actionTypes.ATENDIMENTO.INICIAR_ATENDIMENTO, input)
                this.mostrarNotificacaoSucessoDefault()
                if (resposta) {
                    this.$emit('atendimentoSalvo', resposta)
                }
            }
        },
        abrirModalSelecionarDentista() {
            this.modalSelecionarDentista = true
        },
        fecharModalSelecionarDentista() {
            this.modalSelecionarDentista = false
        },
        async selecionarDentista(dentista) {
            this.dentistaSelecionado = dentista
            this.fecharModalSelecionarDentista()
        },
        isEventoValido() {
            if (!this.dadosGerais.descricao || this.dadosGerais.descricao.length < 5) {
                this.mostrarNotificacaoErro('A descrição deve possuir no mínimo 5 caracteres!')
                return false
            }
            if (!this.dentistaSelecionado.id) {
                this.mostrarNotificacaoErro('Informe o dentista!')
                return false
            }
            return true
        },
    }
}
</script>

<style scoped lang="stylus">

.container-atendimento
  border solid 1px #e0e0e0
  border-radius 10px
  height 480px
  display flex
  flex-direction column

  .v-card__title
    color white
    background-color var(--theme-primary)

.card-content
  flex 1 1 auto
  overflow-y auto

.actions-footer
  justify-content flex-end
  border-top 1px solid rgba(0, 0, 0, 0.12)

.container-header-atendimendo-selecionado
  display flex

.selecionado-label > span
  font-weight bold

.textarea-descricao >>> .v-label
  top 10px !important

.botao-cancelar-edicao:hover
  color orange !important

.botao-salvar:hover
  color #22bb33 !important

</style>